import { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectUserInfo } from '../../main/store/User/reducer';
import { FlowPatternOption } from '../../constants/FlowPatternsType';
import { UserAlertNotificationsFlow } from '../../constants/UserAlertNotificationsFlow';
import { LicenseCodename } from '../../main/constants/LicenseCodename';
import { demoAlertNotificationTemplate } from './templates/licensesAlertNotification';
import {
    UserAlertNotificationsFlowStyles,
    useUserAlertNotificationsFlowStyles,
} from './useUserAlertNotificationsFlow.styles';

export interface IUseUserAlertNotificationsFlowExports {
    userAlertNotification: FlowPatternOption<UserAlertNotificationsFlow, ReactNode> | undefined;
}

export const useUserAlertNotificationsFlow = (): IUseUserAlertNotificationsFlowExports => {
    const user = useSelector(selectUserInfo);
    const classes: UserAlertNotificationsFlowStyles = useUserAlertNotificationsFlowStyles();

    const [userAlertNotification, setUserAlertNotification] = useState<
        FlowPatternOption<UserAlertNotificationsFlow, ReactNode> | undefined
    >();

    const findValidOption = (
        userAlertNotificationsOptions: FlowPatternOption<UserAlertNotificationsFlow, ReactNode>[]
    ): FlowPatternOption<UserAlertNotificationsFlow, ReactNode> | undefined =>
        userAlertNotificationsOptions.find((option: FlowPatternOption<UserAlertNotificationsFlow, ReactNode>) =>
            option?.isValid()
        );

    const findUserAlertNotification = (): FlowPatternOption<UserAlertNotificationsFlow, ReactNode> | undefined => {
        const userAlertNotifications: FlowPatternOption<UserAlertNotificationsFlow, ReactNode>[] = [
            {
                flow: UserAlertNotificationsFlow.DemoLicense,
                isValid: () => user?.codename === LicenseCodename.demo,
                action: () => demoAlertNotificationTemplate(classes),
            },
        ];

        return findValidOption(userAlertNotifications);
    };

    useEffect(() => {
        if (user?.accountId) {
            setUserAlertNotification(findUserAlertNotification());
        }
    }, [user]);

    return {
        userAlertNotification,
    };
};
